import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { SnackbarComponent } from './SnackBar';

const snackbarStyle = (theme) => ({
  margin: {
    margin: theme.spacing.unit,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
    color: 'white',
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class WamNow extends React.Component {
  handleClose = (e) => {
    e.stopPropagation();
    this.props.hideMe();
  };

  handleGo = (e) => {
    e.stopPropagation();
    this.props.switchToWamChannel(this.props.channelId);
    this.props.hideMe();
  };

  render() {
    const { classes, imgSrc, open } = this.props;
    return (
      <SnackbarComponent
        handleClose={this.handleClose}
        handleGo={this.handleGo}
        classes={classes}
        open={open}
        imgSrc={imgSrc}
      />
    );
  }
}

WamNow.propTypes = {
  classes: PropTypes.object.isRequired,
  switchToWamChannel: PropTypes.func.isRequired,
  hideMe: PropTypes.func.isRequired,
  imgSrc: PropTypes.string.isRequired,
  channelId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};

export const WamNowComponent = withStyles(snackbarStyle)(WamNow);
